import { Injectable, inject } from '@angular/core';
import { Store, select, type Selector } from '@ngrx/store';
import { take } from 'rxjs/operators';
import type { AppState } from '../store/app.state';

@Injectable({
    providedIn: 'root'
})
export class StoreProvider {
    private _store = inject<Store<AppState>>(Store);

    getStoreInstantValue<T>(selector: Selector<AppState, T>): T {
        let value: T | null = null;
        this._store.pipe(select(selector), take(1)).subscribe(v => {
            value = v;
        });
        return value!;
    }
}
